import Component from '@glimmer/component';

import { get } from '@ember/helper';
import { action } from '@ember/object';
import didUpdate from '@ember/render-modifiers/modifiers/did-update';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import DynamicNode from 'rise-ui/components/dynamic-node.gjs';
import UiPageTitle from 'rise-ui/components/ui-page/title.gjs';
import UiPageBody from 'rise-ui/components/ui-page/body.gjs';
import copyKeys from 'rise-ui/helpers/copy-keys.js';
import hasBlocks from 'rise-ui/helpers/has-blocks.js';
import isSet from 'rise-ui/helpers/is-set.js';
import isUnset from 'rise-ui/helpers/is-unset.js';
import or from 'rise-ui/helpers/or.js';
import syncState from 'rise-ui/helpers/sync-state.js';
import { softSetProperties } from 'rise-ui/utils/object.js';

export default class UiPageComponent extends Component {
  @service uiPages;
  @tracked page;

  constructor() {
    super(...arguments);
    const { location, page } = this.args;
    this.onPage(null, [ location, page ]);
  }

  @action onPage(el, [ location, page ]) {
    if (softSetProperties(this, { _location: location, _page: page }, true)) {
      this.__page = page || (location && this.uiPages.get(location));
    }
    this.page = this.__page;
  }

  <template>
    {{#let
      (hasBlocks
        "error" (has-block "error")
        "title" (has-block "title")
        "body" (has-block "body")
        noBlock=@noBlock
      )
      (isSet this.page)
      (get (syncState this.page) "title")
      as | hasBlocks hasPage title |
    }}
    <div
      {{didUpdate this.onPage @location @page}}
    >
      {{#if (or hasPage hasBlocks.isNotEmpty)~}}
        {{#if (or title hasBlocks.title)~}}
          <UiPageTitle>
            {{~#if title~}}
              {{title}}
            {{~else~}}
              {{yield to="title"}}
            {{~/if~}}
          </UiPageTitle>
        {{~/if}}
        <UiPageBody @page={{this.page}} @data={{@data}}
          @hasError={{or (isUnset this.page) this.page.isRejected}}
          @noBlock={{copyKeys hasBlocks.noBlock "error"}}
        >
          <:error>{{yield to="error"}}</:error>
          <:default>
            {{~#if this.page.isResolved~}}
              <DynamicNode @node={{this.page.value.bodyProcessed}} @data={{@data}} />
            {{~else~}}
              {{yield to="body"}}
            {{~/if~}}
          </:default>
        </UiPageBody>
      {{~/if}}
    </div>
    {{/let}}
  </template>
}
